import { DialogConfigInterface } from '../../../shared/components/dialog';

export class ProcessResultInformationData {
    private readonly config: DialogConfigInterface;

    caption: string;
    result: string;


    constructor(caption: string, result: string, failed = false) {
        this.caption = caption;
        this.result = result;

        this.config = {
            process: {
                loading: false,
                finished: !failed,
                failed,
                failedMessage: this.result,
                succeedMessage: this.result
            },
            buttons: [],
            buttonsDisabled: false,
            buttonsHidden: false
        };
    }

    getConfig(): DialogConfigInterface {
        return this.config;
    }
}
